export default {
      id: "oc-s3-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-s3",
      toString: function () {
        return this.url;
      }
    }